// 세금계산서 발행 요청 결재(스위치) ON일 때 쓰는 발행요청 다이얼로그.
//
// 평소 "발행요청" 버튼은 단순 확인(AskDialog)이었지만, 결재를 쓰도록 설정되어 있으면
// 상신 전에 결재선 템플릿을 먼저 골라야 한다(사용자 결정 2026-10-21: "결재선 템플릿을
// 고른다, 예: 수주품의서"). 결재선 템플릿은 문서종류로 좁히지 않고 전부 보여준다 -
// ApprovalV2Service.submitDocument가 lineId 소유자만 확인하고 docType 일치는 요구하지
// 않아서, 사용자가 이미 갖고 있는 "수주품의서" 템플릿을 세금계산서 발행 요청에도 그대로
// 쓸 수 있다.
import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import * as approvalV2Api from '../../lib/api/approvalV2';

const IssueApprovalRequestDialog = ({ open, target, onCancel, onConfirm }) => {
  const [lines, setLines] = useState([]);
  const [lineId, setLineId] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLineId('');
    setLoading(true);
    // docType 없이 조회 - 이 사용자의 모든 결재선 템플릿(예: "수주품의서")을 그대로 쓸 수 있게 한다.
    approvalV2Api
      .getApprovalV2Lines({})
      .then((res) => setLines(res?.data?.list || []))
      .finally(() => setLoading(false));
  }, [open]);

  const handleConfirm = async () => {
    if (!lineId) return;
    setSubmitting(true);
    try {
      await onConfirm(lineId);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>세금계산서 발행 요청 - 결재선 선택</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          결재를 사용하도록 설정되어 있습니다. "{target?.invTxt || target?.invNo}" 발행 요청을
          상신할 결재선 템플릿을 선택하세요. 승인되면 발행완료 처리를 진행할 수 있습니다.
        </Typography>
        {loading ? (
          <Typography variant="body2" color="text.secondary">결재선 템플릿을 불러오는 중…</Typography>
        ) : lines.length === 0 ? (
          <Typography variant="body2" color="warning.main">
            등록된 결재선 템플릿이 없습니다. 환경설정 &gt; 결재 설정에서 먼저 템플릿을 만들어 주세요.
          </Typography>
        ) : (
          <FormControl component="fieldset" fullWidth>
            <RadioGroup value={lineId} onChange={(e) => setLineId(e.target.value)}>
              {lines.map((line) => (
                <FormControlLabel
                  key={line.lineId}
                  value={line.lineId}
                  control={<Radio size="small" />}
                  label={`${line.lineNm} (${line.stepCount}단계)`}
                />
              ))}
            </RadioGroup>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={submitting}>취소</Button>
        <Button
          variant="contained"
          disabled={!lineId || submitting}
          onClick={handleConfirm}
        >
          결재 상신
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IssueApprovalRequestDialog;
